export const formatCurrency = (currency, digits = 2) => new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
});

export const formatPrice = (price, isUkMode) => {
    if (!isUkMode) {
        return price;
    }
    return Number(price) % 1 === 0
        ? `${Number(price)}`
        : `${Number(price).toFixed(2)}`;
};
